import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/reduc_co2_icon.png'
import _imports_1 from '@/assets/flexhorizon_color.svg'


const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"flex flex-column p-3 gap-3 justify-content-evenly h-full\"><div class=\"flex align-items-center gap-3\"><img src=\"" + _imports_0 + "\" style=\"height:75%;\"><span class=\"app-label font-bold text-gray-d1\">Réduction de facture éléctrique et d&#39;empreinte carbone</span></div><div class=\"flex align-items-center justify-content-center gap-2 flex-wrap\"><span class=\"app-label text-gray-l1 font-bold white-space-nowrap\">L&#39;offre de notre partenaire</span><img src=\"" + _imports_1 + "\" style=\"height:13px;\"></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CardTopRightButton = _resolveComponent("CardTopRightButton")!

  return (_openBlock(), _createElementBlock("div", {
    class: "pannel relative cursor-pointer",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.flexhorizonRegistration && _ctx.flexhorizonRegistration(...args)))
  }, [
    _createVNode(_component_CardTopRightButton, { icon: "ci-arrows-back" }),
    _hoisted_1
  ]))
}